// Value of properties for source object woun't be changed by target object
// If source of target hase unique properties they are going to be created in resulted object

export function mergeObjects(target, source, optionsArgument){
    return deepmerge(target, source, optionsArgument)
}



/* Deepmerge - Start */
// this code was copied from  https://codepen.io/pushpanathank/pen/owjJGG
// Basicaly I need it to marge field models
function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object'

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}


function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}


function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}


function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice()
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument)
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument)
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument))
        }
    })
    return destination
}


function mergeObject(target, source, optionsArgument) {
    var destination = {}
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument)
        })
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument)
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument)
        }
    })
    return destination
}

function deepmerge(target, source, optionsArgument) {
    target = target !== undefined ? target : {};
    source = source !== undefined ? source : {};
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge }
    var arrayMerge = options.arrayMerge || defaultArrayMerge

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
}
/* Deepmerge - Ends */


// // Sample
// const defaultPerson = {
//   name: 'Push',
//   gender: 'Male',
//   hair: {
//     color: 'Black',
//     cut: 'Short'
//   },
//   eyes: 'blue',
//   family: ['mom', 'dad']
// };

// const me = {
//   name: 'Nathan',
//   gender: 'Male',
//   hair: {
//     cut: 'Long'
//   },
//   family: ['wife', 'kids', 'dog']
// };

// const result1 = deepmerge(defaultPerson, me);
// document.getElementById('result1').innerHTML = JSON.stringify(result1, null, "\t");

// const result2 = deepmerge.all([,
//   { level1: { level2: { name: 'Push', parts: ['head', 'shoulders'] } } },
//   { level1: { level2: { face: 'Round', parts: ['knees', 'toes'] } } },
//   { level1: { level2: { eyes: 'Black', parts: ['eyes'] } } },
// ]);

// document.getElementById('result2').innerHTML = JSON.stringify(result2, null, "\t");